import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { CardOption, E2eIdDirective } from '@lc/ui';
import { MatButton } from '@angular/material/button';
import { CardOptionsComponent } from '@lc/ui/lib/inputs/card-options/card-options.component';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PhotoAppProvidersService } from '../photo-app-providers.service';
import { PhotoAppProvider } from '../models/photo-app-provider.model';

@Component({
  selector: 'lc-app-impersonate-photographer',
  templateUrl: './impersonate-photographer.component.html',
  imports: [AsyncPipe, CardOptionsComponent, MatButton, E2eIdDirective],
})
export class ImpersonatePhotographerComponent {
  private readonly router = inject(Router);
  private readonly providers = inject(PhotoAppProvidersService);
  private readonly reload$ = new BehaviorSubject(true);
  readonly loadError = signal(false);
  selectedPhotographer?: PhotoAppProvider;

  readonly cardOptions$ = this.reload$.pipe(
    tap(() => { this.loadError.set(false); this.selectedPhotographer = undefined; }),
    switchMap(() => this.providers.list$().pipe(
      map((providers) => providers.map((provider) => {
        return new CardOption(provider, provider.title, false, provider.thumbnailUri, provider.thumbnailUri);
      })),
      tap((options) => {
        if (options.length === 1) {
          this.selectedPhotographer = options[0].model;
          this.onSubmit();
        }
      }),
      catchError(() => {
        this.loadError.set(true);
        return of<CardOption<PhotoAppProvider>[]>([]);
      }),
    )),
  );

  onSelected(options: CardOption<PhotoAppProvider>[]) {
    this.selectedPhotographer = options[0]?.model;
  }

  onSubmit() {
    if (this.selectedPhotographer) this.router.navigate(['/appointment-list', this.selectedPhotographer.id]);
  }

  retry() {
    this.reload$.next(true);
  }
}
